import { PortNumber } from '@/sections/insights/queryBuilder/entities/ports/filters/PortNumber';
import { PortProtocol } from '@/sections/insights/queryBuilder/entities/ports/filters/PortProtocol';
import { PortService } from '@/sections/insights/queryBuilder/entities/ports/filters/PortService';
import type { SimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/types';

/**
 * Get simple filter definitions for Port entity
 * Returns field names mapped to available values and operators
 *
 * @returns Array of filter names to SimpleFilterDefinition
 */
export function getPortSimpleFilters(): SimpleFilterDefinition[] {
  return [PortProtocol, PortService, PortNumber];
}
